import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withRouter, Link } from 'react-router-dom';
import Mixpanel from 'utils/mixpanelService';
import { makeSelectAuth } from 'containers/Auth/selectors';
import { makeSelectAllowSignIn } from 'containers/Main/selectors';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getColorAndColorName } from 'containers/Assessments/utils';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import HeartEmptyIcon from 'components/SaveAsFavorite/images/heart-empty-white.svg';
import HeartFullIcon from 'components/SaveAsFavorite/images/heart-full-white.svg';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import _isUndefined from 'lodash/isUndefined';
import { getImageFile } from 'utils/stringUtils';
import TakeArrow from './images/assessment-arrow.svg';

const styles = theme => ({
  cardRoot: {
    boxShadow: 'none !important',
    borderRadius: 0,
    border: `1px solid transparent`,
    textAlign: 'center',
    height: 348,
    position: 'relative',
    backgroundColor: 'transparent',
    zIndex: 1,
  },
  root: {
    height: 'calc(100% - 40px)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'flex-start',
  },
  topContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: 58,
  },
  favoriteIcon: {
    paddingRight: 10,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    padding: 0,
    borderRadius: 0,
    backgroundColor: 'transparent',
    '&:hover': {
      background: 'none',
    },
  },
  heart: {
    width: 26,
  },
  badge: {
    position: 'absolute',
    height: 59,
    left: 18,
    background: theme.palette.primary.main,
    width: 46,
    '&>h6': {
      color: '#fff',
      ...theme.typography.body1,
    },
  },
  timeLabel: {
    color: '#fff',
    ...theme.typography.pxSmall,
  },
  infoContainer: {
    height: 'calc(100% - 59px)',
    paddingTop: 18,
    paddingLeft: 18,
    paddingRight: 18,
  },
  link: {
    textDecoration: 'none',
    color: 'white',
    lineHeight: 'normal',
    fontFamily: 'Mada-Medium',
  },
  actionRoot: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 8,
    paddingBottom: 8,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    fontSize: 17,
  },
  takeArrow: {
    marginLeft: '20%',
  },
  takeAction: {
    paddingLeft: 18,
    paddingRight: 0,
    paddingTop: 8,
    paddingBottom: 8,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: 'white',
    ...theme.typography.button,
  },
  actionContainer: {
    position: 'absolute',
    bottom: 10,
  },
  titleLink: {
    textDecoration: 'none',
    color: 'white',
  },
  title: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: 'white',
    fontSize: 16,
  },
  name: {
    display: 'flex',
    justifyContent: 'flex-start',
    color: 'white',
    fontSize: 24,
    lineHeight: '32px',
    fontWeight: 'bold',
    height: 128,
    overflow: 'hidden',
    whiteSpace: 'normal',
  },
});

class AssessmentsItem extends React.PureComponent {
  redirect = (redirectUrl, type, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const {
      item: {
        fields: { name },
      },
      recommendation,
    } = this.props;
    const pageName = this.props.location.pathname.split('/')[1];
    const finalPageName = pageName ? `${pageName}Page` : 'homePage';
    let event;
    switch (type) {
      case 0:
        event = 'Resource Card - Clicked';
        break;
      case 1:
        event = 'Retake Assessment';
        break;
      case 2:
        event = 'View Assessment Results';
        break;
      case 3:
        event = 'Take Assessment';
        break;
      default:
        event = '';
    }
    Mixpanel.track(event, {
      name,
      type: 'assessment',
      page: finalPageName,
      recommendation,
    });
    this.props.history.push(redirectUrl);
  };

  handleSave = e => {
    e.preventDefault();
    e.stopPropagation();

    const {
      item: {
        fields: { name, time, callToAction = null, slug },
        sys: { id },
      },
      saved,
    } = this.props;
    this.props.save(id, slug, name, time, callToAction, saved);
  };

  render() {
    const {
      classes,
      item,
      item: {
        fields: { name, slug, time },
      },
      saved,
      taken,
      carousel,
      allowSignIn,
      wide,
    } = this.props;

    const imageUrl = getImageFile(item.fields);

    const { color } = getColorAndColorName(item);
    const cardRootStyle = imageUrl
      ? {
          backgroundImage: `url(${imageUrl})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          position: 'absolute',
          opacity: 0.2,
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: -1,
        }
      : {};
    const cardRootColor = {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: color.main,
      zIndex: -2,
    };
    return (
      <Grid item xs={12} sm={carousel ? 12 : wide ? 3 : 4} key={slug}>
        <Paper className={classes.cardRoot}>
          {imageUrl && <div style={cardRootStyle} />}
          <div style={cardRootColor} />
          <Link
            to={`/assessments/${slug}`}
            onClick={() => this.redirect(`/assessments/${slug}`, 0)}
            className={classes.link}
          >
            <Grid container className={classes.root}>
              <Grid item xs={12} className={classes.topContainer}>
                {allowSignIn && (
                  <div className={classes.favoriteIcon}>
                    {saved && (
                      <IconButton
                        className={classes.icon}
                        onClick={this.handleSave}
                        disableRipple
                      >
                        <img
                          src={HeartFullIcon}
                          alt="Full"
                          className={classes.heart}
                        />
                      </IconButton>
                    )}
                    {!saved && !_isUndefined(saved) && (
                      <IconButton
                        className={classes.icon}
                        onClick={this.handleSave}
                        disableRipple
                      >
                        <img
                          src={HeartEmptyIcon}
                          alt="Empty"
                          className={classes.heart}
                        />
                      </IconButton>
                    )}
                  </div>
                )}
                <div className={classes.badge}>
                  <Typography variant="body1">{time}</Typography>
                  <Typography className={classes.timeLabel}>
                    {time < 2 ? `MIN` : `MINS`}
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} className={classes.infoContainer}>
                <Typography
                  variant="overline"
                  color="secondary"
                  className={classes.title}
                >
                  Assessment
                </Typography>
                <div className={classes.titleLink}>
                  <Typography
                    variant="h4"
                    color="primary"
                    className={classes.name}
                    gutterBottom
                    align="left"
                  >
                    {name}
                  </Typography>
                </div>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              spacing={1}
              className={classes.actionContainer}
            >
              {!taken ? (
                <Grid item xs={12}>
                  <ButtonBase
                    variant="text"
                    disableRipple
                    component="span"
                    onClick={() => this.redirect(`/assessments/${slug}`, 3)}
                    classes={{
                      root: classes.takeAction,
                    }}
                  >
                    TAKE ASSESSMENT
                    <img src={TakeArrow} alt="" className={classes.takeArrow} />
                  </ButtonBase>
                </Grid>
              ) : (
                <>
                  <Grid item xs={12}>
                    <ButtonBase
                      variant="text"
                      disableRipple
                      component="span"
                      href={`/assessments/${slug}/results`}
                      onClick={e =>
                        this.redirect(`/assessments/${slug}/results`, 2, e)
                      }
                      classes={{
                        root: classes.takeAction,
                      }}
                    >
                      VIEW RESULTS
                    </ButtonBase>
                  </Grid>
                  <Grid item xs={12}>
                    <ButtonBase
                      variant="text"
                      disableRipple
                      component="span"
                      href={`/assessments/${slug}`}
                      onClick={() => this.redirect(`/assessments/${slug}`, 1)}
                      classes={{
                        root: classes.takeAction,
                      }}
                    >
                      RETAKE ASSESSMENT
                      <img
                        src={TakeArrow}
                        alt=""
                        className={classes.takeArrow}
                      />
                    </ButtonBase>
                  </Grid>
                </>
              )}
            </Grid>
          </Link>
        </Paper>
      </Grid>
    );
  }
}

AssessmentsItem.propTypes = {
  classes: PropTypes.object,
  item: PropTypes.object,
  save: PropTypes.func,
  saved: PropTypes.bool,
  taken: PropTypes.bool,
  history: PropTypes.object,
  location: PropTypes.object,
  carousel: PropTypes.bool,
  recommendation: PropTypes.bool,
  allowSignIn: PropTypes.bool,
  wide: PropTypes.bool,
};

AssessmentsItem.defaultProps = {
  carousel: false,
};

const mapStateToProps = createStructuredSelector({
  allowSignIn: makeSelectAllowSignIn(),
  auth: makeSelectAuth(),
});

const withConnect = connect(mapStateToProps);

export default compose(
  withRouter,
  withConnect,
  withStyles(styles),
)(AssessmentsItem);
